import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import EmailInput from "../../Components/Inputs/EmailInput";
import Switch from "../../Components/Inputs/Switch";

export default function ({register, watch, errors}) {
  return (
    <>
      <Switch
        label="Legal Entity"
        name="is_legal"
        parentClasses="col-md-12 mt-10 active-notactive"
        register={register}
      />

      <TextInput
        label={!watch('is_legal') ? "First Name" : "Name"}
        name="first_name"
        parentClasses="col-md-6"
        register={register}
        required={true}
        errorMessage={errors?.first_name}
      />

      {
        !watch('is_legal') && (
          <TextInput
            label="Last Name"
            name="last_name"
            parentClasses="col-md-6"
            register={register}
            required={true}
            errorMessage={errors?.last_name}
          />
        )
      }

      {
        watch('is_legal') && (
          <>
            <TextInput
              label="Identification code"
              name="identification_code"
              parentClasses="col-md-6"
              register={register}
              required={true}
              errorMessage={errors?.identification_code}
            />

            <TextInput
              label="Phone"
              name="phone"
              parentClasses="col-md-12"
              register={register}
              required={true}
              errorMessage={errors?.phone}
            />
          </>
        )
      }

      <EmailInput
        label="Email"
        name="email"
        parentClasses="col-md-12"
        register={register}
        required={true}
        errorMessage={errors?.email}
      />
    </>
  );
}